import styled from "styled-components"

const Title = styled.h2`

    &::after {
        background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    }
    }
`
const SectionAlert = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const SectionAlertButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const SectionAlertContent = styled.div`
  & a::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & h2,
  & h3,
  & h4 {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const BandeauContainer = styled.section`
  background-color: ${(props) => props.theme.b_color_gradients.b_light};
`

export {
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
  BandeauContainer,
}
